
let singleton = null 

export function cursor() {

	if (singleton) return singleton

	const easing = 0.2
	const html = document.documentElement

	const data = {
		screenX: html.clientWidth, 
		screenY: html.clientHeight,
		x: html.clientWidth / 2, 
		y: html.clientHeight / 2,
		percentX: 0,
		percentY: 0,
		// iterate closer to the target x/y values in each tick
		easedX: html.clientWidth / 2,
		easedY: html.clientHeight / 2,
		easedPercentX: 0,
		easedPercentY: 0,
	}

	const functions = []

	function onUpdate(fn) {
		functions.push(fn)
	}

	function updateFns() {
		functions.map(fn => fn(data))
	}

	function onResize() {
	    data.screenX = html.clientWidth
	    data.screenY = html.clientHeight
	    updateFrame()
	}

	function onMouseUpdate(e) {
	    data.x = e.pageX - window.scrollX
	    data.y = e.pageY - window.scrollY
	    // re-centre axis to centre of screen
	    data.percentX = 2 * ((data.x / data.screenX) - 0.5)
	    data.percentY = 2 * ((data.y / data.screenY) - 0.5)
	    updateFrame()
	}

	let id
	function updateFrame() {
		if (id) return
		id = window.requestAnimationFrame(() => {
			window.cancelAnimationFrame(id)
			id = false
			data.easedX = lerp(data.easedX || 0, data.x, easing)
			data.easedY = lerp(data.easedY || 0, data.y, easing)
			data.easedPercentX = 2 * ((data.easedX / data.screenX) - 0.5)
			data.easedPercentY = 2 * ((data.easedY / data.screenY) - 0.5)
			updateFns()
			if (
				Math.abs(data.easedX - data.x) < 2 &&
				Math.abs(data.easedY - data.y) < 2
			) return
			updateFrame()
		})
	}

	function setupEvents() {
		window.addEventListener('mousemove', onMouseUpdate)
		window.addEventListener('mouseenter', onMouseUpdate)
		window.addEventListener('resize', onResize)
	}

	function removeEvents() {
		window.removeEventListener('mousemove', onMouseUpdate)
		window.removeEventListener('mouseenter', onMouseUpdate)
		window.removeEventListener('resize', onResize)
	}

	setupEvents()

	return singleton = {
		onUpdate,
		removeEvents,
		update: updateFns
	}
}

function lerp(a, b, t) {
    return a * (1 - t) + b * t;
}